import * as BABYLON from "babylonjs";
import RootObjects from "./RootObjects";
import AudioManager from "scripts/util/AudioManager";
import EventPubSub from "scripts/util/EventPubSub";
import AssetLoader from "../loaders/AssetLoader";

class Snowman {
  constructor(container, label = "hello") {
    this.container = container;
    this.label = label;
    this.active = false;
    this.throwing = false;
    this.arcing = false;
    this.animThrow = null;
    this.animIdle = null;
    this.snowball = null;
    this.view = new BABYLON.TransformNode("SNOWMAN" + label);
    this.view.rotationQuaternion = null;

    //animations
    const anim0 = container.animationGroups[0];
    const anim1 = container.animationGroups[1];
    if (anim0.name.includes("Idle")) this.animIdle = anim0;
    else this.animThrow = anim0;
    if (anim1.name.includes("Idle")) this.animIdle = anim1;
    else this.animThrow = anim1;

    // blending
    for (let s = 0; s < container.skeletons.length; s++) {
      const skelly = container.skeletons[s];
      skelly.animationPropertiesOverride =
        new BABYLON.AnimationPropertiesOverride();
      skelly.animationPropertiesOverride.enableBlending = true;
      skelly.animationPropertiesOverride.blendingSpeed = 0.05;
    }

    this.container.rootNodes[0].parent = this.view;
    this.container.rootNodes[0].rotationQuaternion = null;
    this.container.rootNodes[0].rotation.y = 0;

    // this.pointlight = new BABYLON.PointLight("SNOWMAN-pointLight", new BABYLON.Vector3(0,2,0));
    // this.pointlight.intensity=1000;
    // this.pointlight.parent =  this.view;

    this.showSnowman(false);
  }

  showSnowman(show) {
    this.container.rootNodes[0].getChildren((mesh) => {
      mesh.isVisible = show;
      // never show ground plane
      if (mesh.name.includes("Plane001")) mesh.isVisible = false;
      if (mesh.name.includes("snowball")) this.snowball = mesh;

      if (mesh.material && mesh.material.id === "hat&scarf") {
        const hatScarfLMap = AssetLoader.getTexture("SnowmanHatScarfLightmap");
        mesh.material.lightmapTexture = hatScarfLMap;
        if (mesh.material.lightmapTexture) {
          mesh.material.lightmapTexture.uAng = Math.PI;
        }
      }
      if (mesh.material && mesh.material.id === "Snowman") {
        const snowLMap = AssetLoader.getTexture("SnowmanMeshLightmap");
        mesh.material.lightmapTexture = snowLMap;
        if (mesh.material.lightmapTexture) {
          mesh.material.lightmapTexture.uAng = Math.PI;
        }
      }
    }, false);
  }

  placeSnowman(config, myParent, num) {
    this.view.rotationQuaternion = null;
    this.container.rootNodes[0].rotationQuaternion = null;
    this.container.rootNodes[0].rotation.y = 0;
    this.view.position = config.position;

    this.view.rotate(BABYLON.Axis.X, config.rotation.x, BABYLON.Space.LOCAL);
    this.view.rotate(BABYLON.Axis.Y, config.rotation.y, BABYLON.Space.LOCAL);
    this.view.rotate(BABYLON.Axis.Z, config.rotation.z, BABYLON.Space.LOCAL);

    this.view.scaling = new BABYLON.Vector3(
      config.scaling.x,
      config.scaling.y,
      config.scaling.z
    );

    this.view.parent = myParent;
    this.showSnowman(true);
    this.alive = true;
    this.throwing = false;
    // this.animIdle.reset().play(true); //setRandomTimeout
    setTimeout(() => {
      this.animIdle.reset().play(true);
      console.log("START SNOWMAN", num);
    }, (num % 2) * 6000);
  }

  // if (!this.throwing[i] && this.alive[i]) {
  //   if (!this.sled) this.sled = RootObjects.getObject("sled");
  //   const pos = this.views[i].getAbsolutePosition();
  //   const dist = pos.y * pos.y + pos.z * pos.z;
  //   if (dist <= 1000) {
  //     const userDist = Math.abs(pos.x - this.sled.view.position.x);
  //     if (userDist < 15) {
  //       // 10
  //       if (pos.z < -10) {
  //         // could make -15 or something depending on speed
  //         // make sure snowman isn't behind sled ADD SOME OFFSET
  //         this.throwing[i] = true;
  //         console.log("I SEE YOU!!!", userDist, pos.z);
  //         // this.containers[i].animationGroups[1].play(false); //false
  //         this.animsThrow[i].play(false);
  //         setTimeout(() => {
  //           AudioManager.playSound("throw");
  //         }, "300");
  //         setTimeout(() => {
  //           EventPubSub.emit("snowSplat");
  //         }, "1000");
  //       }
  //     }
  //   }
  // }
  // if (this.throwing[i]) {
  //   if (this.animsThrow[i].animatables[0]) {
  //     const frame = this.animsThrow[i].animatables[0].masterFrame;
  //     console.log(
  //       "AIMFRAME:",
  //       this.animsThrow[i].animatables[0].masterFrame
  //     );
  //     if (frame >= 38 && frame <= 50 && !this.arcing[i]) {
  //       this.arcing[i] = true;
  //       this.snowball[i].isVisible = false;
  //     } else if (frame >= 92) {
  //       this.snowball[i].isVisible = true;
  //       this.arcing[i] = false;
  //     }
  //   }
  // }

  // snowmanMeshes STARTS AT 1!!!!!
  update() {
    if (!this.throwing) {
      if (!this.sled) this.sled = RootObjects.getObject("sled");
      if (!this.track) this.track = RootObjects.getObject("track");
      // const pos = this.snowmanMeshes[1].getAbsolutePosition();
      const pos = this.view.getAbsolutePosition();
      const dist = pos.y * pos.y + pos.z * pos.z;
      // if (this.snowman) console.log("snowman!!!", dist);
      if (dist <= 1500) {
        const userDist = Math.abs(pos.x - this.sled.view.position.x);
        if (userDist <= 4) {
          //10
          if (pos.z < -10) {
            // could make -15 or something depending on speed
            // make sure snowman isn't behind sled ADD SOME OFFSET
            this.throwing = true;
            console.log("SNOWMANALERT---uDist:", userDist, " posZ:", pos.z);
            this.animThrow.play(false); //false
            AudioManager.playSound("throw");
            setTimeout(() => {
              if (this.track.starTime <= 0) {
                EventPubSub.emit("snowSplat");
              }
            }, "1000");
          }
        }
      }
    }
  }

  destroy() {
    // this.snowman.parent = null;
    // this.snowman.isVisible = false;
    // this.snowman.dispose();
  }
}

export default Snowman;
